/* =========================
   Ajaxinate Constructor
========================= */
function Ajaxinate(config) {
  var settings = config || {};
  var defaultSettings = {
    method: 'scroll',
    container: '.collection #product-grid',
    pagination: '#AjaxinatePagination',
    offset: 0,
    callback: null
  };

  this.settings = Object.assign(defaultSettings, settings);

  this.containerElement = null;
  this.paginationElement = null;

  this.addScrollListeners = this.addScrollListeners.bind(this);
  this.addClickListener = this.addClickListener.bind(this);
  this.checkIfPaginationInView = this.checkIfPaginationInView.bind(this);
  this.stopMultipleClicks = this.stopMultipleClicks.bind(this);

  this.initialize();
}

/* =========================
   Init (Re-usable)
========================= */
Ajaxinate.prototype.initialize = function () {
  this.removeScrollListeners();

  this.containerElement = document.querySelector(this.settings.container);
  this.paginationElement = document.querySelector(this.settings.pagination);

  if (!this.containerElement || !this.paginationElement) return;

  if (this.settings.method === 'click') {
    this.addClickListener();
  } else {
    this.addScrollListeners();
    this.checkIfPaginationInView();
  }
};

/* =========================
   Scroll Mode
========================= */
Ajaxinate.prototype.addScrollListeners = function () {
  document.addEventListener('scroll', this.checkIfPaginationInView);
  window.addEventListener('resize', this.checkIfPaginationInView);
  window.addEventListener('orientationchange', this.checkIfPaginationInView);
};

Ajaxinate.prototype.checkIfPaginationInView = function () {
  if (!this.paginationElement) return;

  var rect = this.paginationElement.getBoundingClientRect();
  var top = rect.top - this.settings.offset;
  var bottom = rect.bottom + this.settings.offset;

  if (top <= window.innerHeight && bottom >= 0) {
    var link = this.paginationElement.querySelector('a');
    if (!link) return;

    this.nextPageUrl = link.href;
    //link.innerText = this.settings.loadingText;
    this.removeScrollListeners();
    this.loadMore();
  }
};

/* =========================
   Click Mode
========================= */
Ajaxinate.prototype.addClickListener = function () {
  var link = this.paginationElement.querySelector('a');
  if (!link) return;

  this.nextPageLinkElement = link;
  this.clickActive = true;
  link.addEventListener('click', this.stopMultipleClicks);
};

Ajaxinate.prototype.stopMultipleClicks = function (e) {
  e.preventDefault();
  if (!this.clickActive) return;

  this.clickActive = false;
  //this.nextPageLinkElement.innerText = this.settings.loadingText;
  this.nextPageUrl = this.nextPageLinkElement.href;
  this.loadMore();
};

/* =========================
   Ajax Load
========================= */
Ajaxinate.prototype.loadMore = function () {
  var request = new XMLHttpRequest();

  request.onreadystatechange = function () {
    if (request.readyState === 4 && request.status === 200) {
      var doc = request.responseXML;
      var newContainer = doc.querySelector(this.settings.container);
      var newPagination = doc.querySelector(this.settings.pagination);

      if (newContainer) {
        this.containerElement.insertAdjacentHTML('beforeend', newContainer.innerHTML);
      }

      if (newPagination) {
        this.paginationElement.innerHTML = newPagination.innerHTML;
      }

      if (typeof this.settings.callback === 'function') {
        this.settings.callback(doc);
      }

      this.initialize();
    }
  }.bind(this);

  request.open('GET', this.nextPageUrl);
  request.responseType = 'document';
  request.send();
};

/* =========================
   Cleanup
========================= */
Ajaxinate.prototype.removeScrollListeners = function () {
  document.removeEventListener('scroll', this.checkIfPaginationInView);
  window.removeEventListener('resize', this.checkIfPaginationInView);
  window.removeEventListener('orientationchange', this.checkIfPaginationInView);
};

/* =========================
   Auto Re-init on AJAX Filters
========================= */
function reInitAjaxinate() {
  if (window.endlessScroll instanceof Ajaxinate) {
    window.endlessScroll.initialize();
  }
}

/* MutationObserver for filter-based DOM updates */
var ajaxinateObserver = new MutationObserver(function (mutations) {
  mutations.forEach(function (mutation) {
    if (
      mutation.target.matches &&
      (mutation.target.matches('#product-grid') ||
       mutation.target.querySelector && mutation.target.querySelector('#AjaxinatePagination'))
    ) {
      reInitAjaxinate();
    }
  });
});

document.addEventListener('DOMContentLoaded', function () {
  window.endlessScroll = new Ajaxinate();

  ajaxinateObserver.observe(document.body, {
    childList: true,
    subtree: true
  });
});